import { HTTP_METHODS } from "../server/request.constants";

export const jsTypeConstants = {
  STRING: "string",
  FUNCTION: "function",
};

export const httpMethodConstants = {
  GET: HTTP_METHODS.GET,
};

export const setupTestUrlConstants = {
  EMPTY_STRING: "",
  LOCALHOST_URL: "http://localhost",
};
